import { useCallback, useEffect, useMemo, useState } from "react";
import "./theme/variables.scss";
import "./theme/style.scss";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { PreferencesContext } from "./PreferenceContext";
import { getStorage, setStorage } from "./service/common/storage";
import { defaultContext, Context } from "./service/models/Context";
import Alerts from "./components/Alerts";
import { Outlet } from "react-router-dom";

function App() {
  const [mode, setMode] = useState<"light" | "dark" | undefined>(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );
  // const [userContext, setUserContext] = useState<Context>(getStorage());
  const [userContext, setUserContext] = useState<Context>(() => {
    const stored = getStorage();
    return stored ? stored : defaultContext;
  });
  // const updateUserContext = useCallback(
  //   (ctx: any) => {
  //     setStorage(ctx);
  //     return setUserContext(ctx);
  //   },
  //   [userContext]
  // );
  const updateUserContext = useCallback(
    (ctx: Context | ((prev: Context) => Context)) => {
      setUserContext((prev) =>
        typeof ctx === "function"
          ? (ctx as (prev: Context) => Context)(prev)
          : ctx
      );

      const valueToStore =
        typeof ctx === "function"
          ? (ctx as (prev: Context) => Context)(userContext)
          : ctx;

      setStorage(valueToStore); // persist in localStorage
    },
    [userContext]
  );
  // const updateUserContext = useCallback((ctx: Context) => {
  //   setUserContext(ctx);
  //   setStorage(ctx);
  // }, []);
  const preferences = useMemo(
    () => ({
      userContext,
      updateUserContext,
    }),
    [userContext, updateUserContext]
  );

  const theme = createTheme({
    typography: {
      fontFamily: ["RoseauSlab-Light", "sans-serif"].join(","),
    },
    palette: {
      // primary: { main: "#680001", light: "#FAF9F6" },
      primary: { main: "#4C0808", light: "#FAF9F6" },
      secondary: { main: "#091C69", light: "#E6E8F0" },
      action: { hover: "#8c00040d" },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 600,
            padding: "16px 40px",
            borderRadius: "8px",
            background: "#f2f1ee",
          },
        },
      },
    },
  });
  useEffect(() => {
    const localToken = localStorage.getItem("lt");
    if (localToken) {
      updateUserContext((prev) => ({
        ...prev,
        localToken: localToken,
      }));
    }
  }, []);

  // / Remove the resizeObserver error
  useEffect(() => {
    const errorHandler = (e: any) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
            "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PreferencesContext.Provider value={preferences}>
        {userContext && (
          <Alerts
            isOpen={userContext.isAlert}
            displayMessage={userContext.alertMessage}
            type={userContext.alertType}
          />
        )}
        <Outlet context={[mode]} />
      </PreferencesContext.Provider>
    </ThemeProvider>
  );
}

export default App;
